import {ValidateStep3Data} from "@validators/business-insurance-form/step3-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";
import {
   BUSINESS_CATEGORY_OPTIONS,
   BUSINESS_TYPE_OPTIONS,
   INSURER_LIST
} from "@constants/form-optins/business-insurance-options";
import ScrollableDropdownBlock from "@components/common/form-blocks/scrollable/dropdown-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";
import ScrollableCustomDateTimePickerBlock
   from "@components/common/form-blocks/scrollable/custom-datetime-picker-block";

export default function IF_Step4({data, handlers, setCurrentStep}) {
   
   const STEP = 3;
   
   const onPrevBtnClick = (event) => {
      setCurrentStep(STEP - 1);
   }
   
   const onNextBtnClick = (event) => {
      
      let validationResult = ValidateStep3Data(data);
      
      if (validationResult.length) {
         
         showValidationErrorsModal({
            validationResult: validationResult
         });
         
         
      } else {
         setCurrentStep(STEP + 1);
      }
      
      
   }
   
   return (
      <div className={`if-step-${STEP}`}>
         
         <SectionHeading
            text="Company details"
         />

         <div className="row">
            
            {/* Previous Insurer */}
            
            <ScrollableDropdownBlock
               selectedValues={data.previousInsurerName}
               controlName="previousInsurerName"
               containerCssClass="col-12 py-3"
               labelText="Current/Previous insurer"
               required={true}
               options={INSURER_LIST}
               
               onChange={handlers.onControlChange}
               helpText=""
            />
            
            
            {/* Business type */}
            
            <ScrollableDropdownBlock
               selectedValues={data.businessType}
               controlName="businessType"
               containerCssClass="col-12 py-3"
               labelText="Business type"
               required={true}
               options={BUSINESS_TYPE_OPTIONS}
               
               onChange={handlers.onControlChange}
               helpText=""
            />
            
            {/* Business, Company or Partnership name */}
            
            <ScrollableTextBoxBlock
               value={data.businessName}
               containerCssClass="col-12 py-3"
               labelText="Business, Company or Partnership name"
               required={true}
               controlName="businessName"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 50
               }}
            />
            
            {/* Business category */}
            
            <ScrollableDropdownBlock
               selectedValues={data.businessCategory}
               controlName="businessCategory"
               containerCssClass="col-12 py-3"
               labelText="Business category"
               required={true}
               options={BUSINESS_CATEGORY_OPTIONS}
               
               onChange={handlers.onControlChange}
               helpText=""
            />
            
            {"Other" === data.businessCategory && (
               
               <>
                  {/* If other please specify category name */}
                  
                  <ScrollableTextBoxBlock
                     value={data.businessOtherCategory}
                     containerCssClass="col-12 py-3"
                     labelText="If other please specify category name"
                     required={"Other" === data.businessCategory}
                     controlName="businessOtherCategory"
                     
                     onChange={handlers.onControlChange}
                     asTextArea={false}
                     inputAttrs={{
                        maxLength: 50
                     }}
                  />
               </>
               
            )}
            
            {/* What date was your business established? */}
            
            <ScrollableCustomDateTimePickerBlock
               value={data.businessEstablishmentDate}
               containerCssClass="col-12 py-3"
               labelText="What date was your business established?"
               required={true}
               controlName="businessEstablishmentDate"
               
               onChange={handlers.onControlChange}
            />
            
            {/* Total number of employees including partners, principals and directors */}
            
            <ScrollableTextBoxBlock
               value={data.businessNumberOfEmployees}
               containerCssClass="col-12 py-3"
               labelText="Total number of employees including partners, principals and directors"
               required={true}
               controlName="businessNumberOfEmployees"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 6,
                  type: 'number'
               }}
            />
            
            {/* What is your estimated annual turnover? */}
            
            <ScrollableTextBoxBlock
               value={data.businessEstimatedAnnualTurnover}
               containerCssClass="col-12 py-3"
               labelText="What is your estimated annual turnover?"
               required={true}
               controlName="businessEstimatedAnnualTurnover"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 15,
                  type: 'number'
               }}
            />
            
            {/* What is your estimated annual wages? */}
            
            <ScrollableTextBoxBlock
               value={data.businessEstimatedAnnualWages}
               containerCssClass="col-12 py-3"
               labelText="What is your estimated annual wages?"
               required={true}
               controlName="businessEstimatedAnnualWages"
               
               onChange={handlers.onControlChange}
               asTextArea={false}
               inputAttrs={{
                  maxLength: 15,
                  type: 'number'
               }}
            />
         
         </div>
         
         <WizardStepButtonsBlock
            onPrevBtnClick={onPrevBtnClick}
            onNextBtnClick={onNextBtnClick}
            nextButtonAdditionalCssClass={`fixed-bottom2`}
         />
      
      </div>
   );
   
}